function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 99.5,
    r: 81.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "19.71px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48,150c0,0 19.5,-14.833 28,-16c7.384,-1.014 16.667,4.167 23,4c6.333,-0.167 16.171,-5.675 23,-4c8.833,2.167 20.333,12 32,20",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "19.71px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 89.5,
    r: 23.5,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "18.12px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.4b43052c14af0b2071b3a25cce5ac882.svg";
export { ForwardRef as ReactComponent };